import errors from "../errors";
import validate from "../validate";

const { SystemError } = errors;

async function removeCart() {
    try {
        validate.token(sessionStorage.token)

        const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/cart`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${sessionStorage.token}`,
                'Content-Type': 'application/json',
            },
        });

        if (res.status === 200) {
            return await res.json();
        }

        const errorBody = await res.json();
        const { error, message } = errorBody;
        const constructor = errors[error as keyof typeof errors];
        throw new constructor(message);
    } catch (error) {
        throw new SystemError(error instanceof Error ? error.message : "An unknown error occurred");
    }
}

export default removeCart;
